import { FinancingScenario } from '../components/BuybackFormFinancingTable/BuybackFormFinancingTable'
import { FINANCING_SETTINGS } from './buybackConst'

export enum FinancingStatus {
  Approved = 'approved',
  PendingApproval = 'pending_approval',
  Rejected = 'rejected',
}

export interface FinancingStatusResult {
  status: FinancingStatus
  text: string
  className: string
  description: string
}

/**
 * Calculates financing status based on all scenarios
 * @param calculations - object containing scenarios and duration parameters
 * @returns status result with text, className and description
 */
export const calculateFinancingStatus = (calculations: {
  scenarios: FinancingScenario[]
  rentDurationMonths: number
}): FinancingStatusResult => {
  const { scenarios, rentDurationMonths } = calculations

  let minBalance = FINANCING_SETTINGS.balanceWarningLevel

  for (const scenario of scenarios) {
    if (scenario.month <= rentDurationMonths) {
      if (scenario.buybackBalance < minBalance) {
        minBalance = scenario.buybackBalance
      }
      if (scenario.marketBalance < minBalance) {
        minBalance = scenario.marketBalance
      }
    }
  }

  if (minBalance <= 0) {
    return {
      status: FinancingStatus.Rejected,
      text: 'Zamítnuto',
      className: 'text-red-400',
      description: 'Financování není dostupné',
    }
  }

  if (minBalance < FINANCING_SETTINGS.balanceWarningLevel) {
    return {
      status: FinancingStatus.PendingApproval,
      text: 'Ke schválení',
      className: 'text-yellow-500',
      description: 'Riskantní, vyžaduje schválení',
    }
  }

  return {
    status: FinancingStatus.Approved,
    text: 'Předschváleno',
    className: 'text-lime-600',
    description: 'Financování je dostupné',
  }
}
